import * as React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';

const Form = React.forwardRef(({ className, ...props }, ref) => (
  <form
    ref={ref}
    className={cn('space-y-6', className)}
    {...props}
  />
));

Form.displayName = 'Form';

Form.propTypes = {
  className: PropTypes.string,
};

const FormField = React.forwardRef(({ className, name, children, ...props }, ref) => (
  <div ref={ref} className={cn('space-y-2', className)} {...props}>
    {children}
  </div>
));

FormField.displayName = 'FormField';

FormField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
};

const FormItem = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('space-y-1', className)} {...props} />
));

FormItem.displayName = 'FormItem';

FormItem.propTypes = {
  className: PropTypes.string,
};

const FormLabel = React.forwardRef(({ className, children, ...props }, ref) => (
  <label
    ref={ref}
    className={cn('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)}
    {...props}
  >
    {children}
  </label>
));

FormLabel.displayName = 'FormLabel';

FormLabel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const FormControl = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('mt-2', className)} {...props} />
));

FormControl.displayName = 'FormControl';

FormControl.propTypes = {
  className: PropTypes.string,
};

const FormMessage = React.forwardRef(({ className, children, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('text-sm font-medium text-destructive', className)}
    {...props}
  >
    {children}
  </p>
));

FormMessage.displayName = 'FormMessage';

FormMessage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
}; 